import { render, staticRenderFns } from "./quarter_notes.vue?vue&type=template&id=52673377&scoped=true&"
import script from "./quarter_notes.vue?vue&type=script&lang=js&"
export * from "./quarter_notes.vue?vue&type=script&lang=js&"
import style0 from "./quarter_notes.vue?vue&type=style&index=0&id=52673377&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52673377",
  null
  
)

export default component.exports